import React from 'react'
import { theme } from '../../../Assets/Styles/theme'
import IconAdd from '../../../Assets/Images/icons/newIcons/iconAdd'

const ButtonAdd = ({ onClick }) => {
  return (
    <button
      style={{
        width: '24px',
        height: '25px',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
      }}
      onClick={onClick}
    >
      <IconAdd color={theme.colors.primary} />
    </button>
  )
}

export default ButtonAdd
